import  { apiConfig } from "../helpers";
import { authHeader } from '../helpers';
import axios from 'axios';
export const reserveService = {
    create,
    getAll,
    checkReserve,
    getReserve,
    updateReserve,
    deleteReserve,
    getReservesForDay
};

function create(data)
{
    return axios.post('/api/services/app/Reserve/Create',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function getAll(data)
{
    return axios.get('/api/services/app/Reserve/GetAll', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: data
    })
}
function checkReserve(data)
{
    return axios.get('/api/services/app/Reserve/GetReserve', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: data
    })
}
function getReserve(id)
{
    return axios.get('/api/services/app/Reserve/Get', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            Id: id
        }
    })
}
function updateReserve(data)
{
    return axios.put('/api/services/app/Reserve/Update',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function deleteReserve(id)
{
    return axios.delete('/api/services/app/Reserve/Delete', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            Id: id
        }
    })
}
function getReservesForDay(date)
{
    return axios.get('/api/services/app/Reserve/GetReservesForDay', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            date: date
        }
    })
}

